<template>
  <ul class="list-group">
    <li
      class="list-group-item"
      v-for="a in store.accounts"
      :key="a.id"
      @click="attendanceAccount(a.id)"
    >
      {{ a.name }}
      <span class="badge rounded-pill bg-success float-end" v-if="a.attendance"
        >Attendance</span
      >
    </li>
  </ul>
</template>
<script setup>
import { useStore } from "../../store/index";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config.js";
import { ref } from "vue";
const store = useStore();

const attendanceAccount = async (id) => {
  const accountRef = doc(db, "accounts", id);
  await updateDoc(accountRef, {
    attendance: true,
  });
};
</script>
